/** Shared occasion card/chart palettes — teal-adjacent, not competing with brand. */

export const OCCASION_THEMES = [
  {
    primary: "#0d7377",
    primaryDark: "#095456",
    soft: "#e8f5f5",
    border: "#b5d9d9",
    chart: ["#0d7377", "#2a9d8f", "#3d8bfd", "#c47a12", "#5c6bc0", "#d4654a"],
    occupied: "#c47a12",
    available: "#2a8f5c",
  },
  {
    primary: "#2f6f8f",
    primaryDark: "#234f66",
    soft: "#eaf3f8",
    border: "#b8d2e0",
    chart: ["#2f6f8f", "#4a90c2", "#0d7377", "#c47a12", "#5c6bc0", "#d4654a"],
    occupied: "#c47a12",
    available: "#2a8f5c",
  },
  {
    primary: "#3d7a5c",
    primaryDark: "#2c5742",
    soft: "#eaf5ef",
    border: "#b8d9c6",
    chart: ["#3d7a5c", "#4caf7a", "#0d7377", "#2f6f8f", "#c47a12", "#5c6bc0"],
    occupied: "#c47a12",
    available: "#3d7a5c",
  },
  {
    primary: "#8a6b3d",
    primaryDark: "#634c2c",
    soft: "#f6f1e8",
    border: "#e0d2b8",
    chart: ["#8a6b3d", "#c47a12", "#0d7377", "#2f6f8f", "#5c6bc0", "#3d7a5c"],
    occupied: "#8a6b3d",
    available: "#2a8f5c",
  },
  {
    primary: "#5b6b8c",
    primaryDark: "#414d66",
    soft: "#eef0f5",
    border: "#c8cedc",
    chart: ["#5b6b8c", "#7a89a8", "#0d7377", "#2f6f8f", "#c47a12", "#3d7a5c"],
    occupied: "#c47a12",
    available: "#2a8f5c",
  },
  {
    primary: "#7a5f6e",
    primaryDark: "#57434e",
    soft: "#f4eef1",
    border: "#d8c8d0",
    chart: ["#7a5f6e", "#9a7a8a", "#0d7377", "#2f6f8f", "#c47a12", "#5c6bc0"],
    occupied: "#c47a12",
    available: "#2a8f5c",
  },
];

export const getOccasionTheme = (index = 0) => {
  const len = OCCASION_THEMES.length;
  return OCCASION_THEMES[((index % len) + len) % len];
};
